import axios from 'axios';
import QS from 'qs';//需要npm install qs
import getBaseData from '../../static/utils/Common.js'
const urlApi = getBaseData.PORT_ADDRESS;//请求接口地址
const service = axios.create({
  baseURL:urlApi,
  timeout:60000//请求超时时间
});
// 请求拦截器
service.interceptors.request.use(
  config => {
    config.data = QS.stringify(config.data);
    return config
  },
  err => {
    return Promise.reject(err)
  });
// // 响应拦截器
service.interceptors.response.use(
  response => {
    if(response.data.code == 10086){
      localStorage.removeItem('tokenAll');
      localStorage.removeItem('broadcast');
      sessionStorage.removeItem('hasRegD');
      sessionStorage.removeItem('chntokenOther');
      sessionStorage.removeItem('aff_sid');
      location.replace("/?chntoken="+sessionStorage.getItem('chntoken'));
    }
    return response
  },
  //接口错误状态处理，也就是说无响应时的处理
  error => {
    return Promise.reject(error) // 返回接口返回的错误信息
  });

function dealData(d){
  let this_l_time = "";
  let user_id = "";
  let login_token = "";
  if(localStorage.getItem('tokenAll') != undefined){
    this_l_time = JSON.parse(localStorage.getItem('tokenAll')).this_login_time;
    user_id = JSON.parse(localStorage.getItem('tokenAll')).userid;
    login_token = JSON.parse(localStorage.getItem('tokenAll')).login_token;
  }else{
    this_l_time = "";
    user_id = "";
    login_token = "";
  }
  d.this_login_time = this_l_time;
  d.login_token = login_token;
  d.userid = user_id;
  return d
}

// 密码登录
export function loginPassword(data) {return service.post(urlApi+'/h5/Login', data)}

// 认证列表
export function postRenInfo(data) {dealData(data);data.route='/h5/Information';return service.post(urlApi, data)}

//运营商认证
export function yys_varify(data) {dealData(data);data.route='/h5/yys_varify2';return service.post(urlApi,data)}

//运营商是否认证
export function yys_isvarify(data) {dealData(data);data.route='/h5/yys_is_varify';return service.post(urlApi, data)}

//是否显示运营商
export function yys_display(data) {dealData(data);data.route='/h5/yys_display';return service.post(urlApi,data)}

//测试香港上传图片
// export function hongkPostImg(data) { return service.post(urlApi+'/h5/up_img_h5',data)}
export function hongkPostImg(data) {dealData(data);data.route='/h5/up_img_h51';return service.post(urlApi+'v1/upd/img',data)}//加上ocr的判断

// h5阿里云上传图片
export function postAli(data) {dealData(data);data.route='/h5/up_img';return service.post(urlApi,data)}

// 判断图片是否上传完整
export function isPhotosAll(data) {dealData(data);data.route='/h5/check_img';return service.post(urlApi,data)}

// 获取个人信息
export function postUserInfo(data) {dealData(data);data.route='/c6/SelectUserInfo';return service.post(urlApi,data)}

//传递facebook
export function post_facebook(data) {dealData(data);data.route='/c6/fackook_is_read';return service.post(urlApi,data)}

// 提交基本信息
export function postBascInfo(data) {dealData(data);data.route='/h5/Create_task';return service.post(urlApi,data)}

//联系人
export function postContact(data) {dealData(data);data.route='/h5/BaseInfo';return service.post(urlApi,data)}

// 获取银行卡信息
// export function getBanksNews(data) { return service.post(urlApi+'/c1/userBankList',data)}
export function getBanksNews(data) {dealData(data);data.route='/c1/UserBank/userBankList';return service.post(urlApi,data)}

// 获取银行卡列表
export function getBanks(data) {dealData(data);data.route='/c1/bankListALL';return service.post(urlApi,data)}

// 提交银行卡信息
export function postBanks(data) {dealData(data);data.route='/h5/UserBank/AddUserBank';return service.post(urlApi,data)}

// 获取社交信息
export function getSocialNews(data) {dealData(data);data.route='/h5/shejiao_info';return service.post(urlApi,data)}

// 获取借款记录
export function getBorrowlist(data) {dealData(data);data.route='/h5/Borrowlist';return service.post(urlApi,data)}

// 借款详情
export function getBorrowDetails(data) {dealData(data);data.route='/h5/getdetails';return service.post(urlApi,data)}

// 首页聚合接口
export function getAllNews(data) {dealData(data);data.route='/h5/show';return service.post(urlApi,data)}

// 还款接口
export function RepaymentMoney(data) {dealData(data);data.route='/c1/AutomaticLoan/repay_select';return service.post(urlApi,data)}

// 还款方式接口
export function RepaymentMoneyTypes(data) {dealData(data);data.route='/h5/UserBank/admin_bank_set';return service.post(urlApi,data)}

// 续期接口
export function RepaymentXqMoney(data) {dealData(data);data.route='/h5/AutomaticLoan/select_type';return service.post(urlApi,data)}

//获取银行账户
export function getBankAccounts(data) {dealData(data);data.route='/h5/UserBank/getBankCard';return service.post(urlApi,data)}

//判断是否可以续期
export function isXuQi(data) {dealData(data);data.route='/c1/AutomaticLoan/Where_renewal';return service.post(urlApi,data)}

//身份证验证
export function idcard_verify(data) {dealData(data);data.route='/h5/idcard_img_verify';return service.post(urlApi,data)}

// 判断是否修改信息
export function isChangeInfo(data) {dealData(data);data.route='/h5/is_amend_msg';return service.post(urlApi,data)}

// 修改信息
export function ChangedInfo(data) {dealData(data);data.route='/h5/amend_msg';return service.post(urlApi,data)}

// 修改密码
export function modifyPassword(data) {dealData(data);data.route='/h5/setpassword';return service.post(urlApi,data)}

// 修改默认银行卡
export function deBankCard(data) {dealData(data);data.route='/c1/deBankCard';return service.post(urlApi,data)}

//获取客服电话
export function customer_tel(data) {dealData(data);data.route='/h5/customer_service';return service.post(urlApi,data)}

// 登录
export function login(data) {dealData(data);data.route='/h5/LoginCode';return service.post(urlApi,data)}

// 发送验证码
export function sendCode(data) {dealData(data);data.route='/h5/LoginMessage_ultimate';return service.post(urlApi,data)}

// 删除银行卡
export function delBank(data) {dealData(data);data.route='/h5/unbindCard';return service.post(urlApi,data)}

// 借款申请金额列表
export function getBorrowMoney(data) {dealData(data);data.route='/h5/getborrow';return service.post(urlApi,data)}

// 借款接口
export function borrowLoan(data) {dealData(data);data.route='/h5/put_in';return service.post(urlApi,data)}

// 职业信息
export function zhiyeNews(data) {dealData(data);data.route='/c1/InfoList';return service.post(urlApi,data)}

// sass借款记录
export function sassDetailRec(data) {dealData(data);data.route='/c2/Borrowlist';return service.post(urlApi,data)}

// sass借款记录
export function sassIndex(data) {dealData(data);data.route='/c1/show';return service.post(urlApi, data)}

// sass借款
export function sassBorrow(data) {dealData(data);data.route='/c2/loan_apply_for';return service.post(urlApi,data)}

// sass提现
export function sasstx(data) {dealData(data);data.route='/c2/Agreed_status';return service.post(urlApi,data)}

// sass提现详情
export function sasstxDetail(data) {dealData(data);data.route='/c2/getdetails';return service.post(urlApi,data)}

// sass获取官方账户
export function sassGFaccount(data) {dealData(data);data.route='/c1/UserBank/getBankCard';return service.post(urlApi,data)}

// sass获取还款方式
export function sassRepaySty(data) {dealData(data);data.route='/c1/UserBank/admin_bank_set';return service.post(urlApi,data)}

// sass还款详情带进度环
export function sassRepaySecdule(data) {dealData(data);data.route='/c2/get_backmoney';return service.post(urlApi,data)}

// sass重新认证，查询身份证照片
export function sassSearchPhoto(data) {dealData(data);data.route='/c6/check_user_idcard_img';return service.post(urlApi,data)}

// sass重新认证，查询基本信息
export function sassSearchInfo(data) {dealData(data);data.route='/c6/SelectUserInfo';return service.post(urlApi,data)}

// sass重新认证，查询社交信息
export function sassSearchSocial(data) {dealData(data);data.route='/c6/chechk_user_address_list';return service.post(urlApi,data)}

// sass重新认证，查询用户银行卡列表
export function sassSearchBanksList(data) {dealData(data);data.route='/c1/UserBank/userBankList';return service.post(urlApi,data)}

// sass还款接口
export function sassRepayMoney(data) {dealData(data);data.route='/c1/AutomaticLoan/repay';return service.post(urlApi,data)}

// sass重新认证信息的接口
export function sassRestRZ(data) {dealData(data);data.route='/c6/Userinfo_save_order';return service.post(urlApi,data)}

// sass客服电话
export function sassService(data) {dealData(data);data.route='/c1/customer_service';return service.post(urlApi,data)}

// sass已还款，重新借款
export function sassagainLoan(data) {dealData(data);data.route='/c2/again_put_in';return service.post(urlApi,data)}

// sass借款额度
export function sassLoanQuota(data) {dealData(data);data.route='/c2/getborrow_v2';return service.post(urlApi,data)}

//放款查询
export function getLoanProgress(data) {dealData(data);data.route='/h5/order_check';return service.post(urlApi,data)}

//再次开启认证
export function againAttest(data) {dealData(data);data.route='/h5/update_infois';return service.post(urlApi,data)}
//轮播图
export function swipe_notice(data) {dealData(data);data.route='/c1/showHelpList';return service.post(urlApi,data)}
/******2023-3-6新增*****
 * 修改银行卡，新增银行卡新增接口，修改和新增自动设置未默认银行卡，修改默认银行卡接口删除；
 * 新增添加银行卡页面的发送短信功能
 * **********/
export function UserBankSms(data) {dealData(data);data.route='/h5/UserBank/UserBankSms';return service.post(urlApi,data)}
export function UserBankAction(data) {dealData(data);data.route='/h5/UserBank/UserBankAction';return service.post(urlApi,data)}
//在客户点击提现某个产品的时候 如果没有笔数 则弹框提示
export function withdrawTips(data) {dealData(data);data.route='/c2/agree/loan/push';return service.post(urlApi,data)}
//验证是否已经登录
export function isLogin(data) {dealData(data);data.route='/h5/check/login';return service.post(urlApi,data)}
//请求是否已经借款成功
export function hasLoaned(data) {dealData(data);data.route='/c2/getLoanCount';return service.post(urlApi,data)}

//w问题反馈列表
export function newsList(data) {dealData(data);return service.post('https://cui.collectionnice.com/api/h5/feedback/list',data)}
//提交问题反馈
export function subProblem(data) {dealData(data);return service.post('https://cui.collectionnice.com/api/h5/feedback/submit',data)}
//提交已经读了
export function reade(data) {dealData(data);return service.post('https://cui.collectionnice.com/api/h5/feedback/reade',data)}
//问题类型
export function proType(data) {dealData(data);return service.post('https://cui.collectionnice.com/api/h5/feedback/q_type',data)}
//取消授信
export function qxsq(data) {dealData(data);data.route='/c2/cancel/loan/accredit';return service.post(urlApi,data)}
//提现选择额度
export function with_xzed(data) {dealData(data);data.route='/c2/get/loan/set';return service.post(urlApi,data)}
//提现修改额度
export function with_xged(data) {dealData(data);data.route='/c2/upd/loan/set';return service.post(urlApi,data)}
//检测登录状态
export function check_login_status(data) {dealData(data);data.route='/h5/check/login/status';return service.post(urlApi,data)}
//验证码方式
export function newSendOtpType(data) {dealData(data);data.route='/h5/get/sms/type';data.userAgent = window.navigator.userAgent;return service.post(urlApi,data)}



// WEBPACK FOOTER //
// ./src/ports/port.js